import { createEvent } from 'effector';
import { track } from './amplitude';
import { CHAT_PANEL_MODE_CHANGED } from './events';
import { $sceneId } from '../state/appState';
import type { AssistantChatMode } from '../components/AssistantChatPanel';

/**
 * Дискретные изменения режима чат-панели. Дебаунса не нужно — `mode` в
 * `AssistantChatPanel` хранится через `useState` и переключается атомарно
 * в момент drag-end (snap) или programmatic `setRequestedMode`. Во время
 * самого drag'а двигается `shift` (px-offset), не `mode`.
 *
 * `previousMode === null` помечает первый emit на mount панели (initial
 * `useState<...>("hidden")` → `useEffect([mode])`). Так в Amplitude можно
 * отфильтровать фантом-открытие.
 */
export const chatPanelModeChanged = createEvent<{
  previousMode: AssistantChatMode | null;
  newMode: AssistantChatMode;
}>();

export const startChatStateTracking = (): void => {
  chatPanelModeChanged.watch(({ previousMode, newMode }) => {
    track(CHAT_PANEL_MODE_CHANGED, {
      previous_mode: previousMode,
      new_mode: newMode,
      scene_id: $sceneId.getState(),
    });
  });
};
